<template>
  <v-container>
    <v-menu
      v-if="selectedItem !== null"
      v-model="showMenu"
      v-click-outside="close"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      class="menu"
      light
    >
      <v-list v-if="itemsToShow.length">
        <v-list-item
          v-for="(item, index) in itemsToShow"
          :key="index"
          @click="optionSelected(item)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Last item GOOGLE DOCS EXPORTER -->
        <v-list-item v-if="exportToGoogleDocs" class="googlePickerButton" @click="optionSelected({ref: 'exportDrive'})">
          <v-list-item-action>
            <v-icon>cloud_download</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Export to Google Drive</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- GOOGLE PICKER NOT USED - OAUTH 2 CLIENT  -->
        <!-- <GooglePicker v-if="exportToGoogleDocs" class="googlePickerButton" :selectedItem="selectedItem"> </GooglePicker> -->
      </v-list>
    </v-menu>

    <!-- MoveTo pop up --->
    <MoveTo :ref="(el) => refs.moveToPopup = el" />

    <!-- Delete pop up --->
    <Delete :ref="(el) => refs.deletePopup = el" />

    <!-- Rename folder pop up --->
    <RenameFolder :ref="(el) => refs.renamePopup = el" />

    <!-- Copy file pop up --->
    <Copy :ref="(el) => refs.copyPopup = el" />

    <!-- Export File to Google Drive --->
    <ExportToDrive :ref="(el) => refs.exportDrive = el" />
  </v-container>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue';

import { useStore } from 'vue2-helpers/vuex';

import MoveTo from './MoveTo.vue';
import Delete from './Delete.vue';
import RenameFolder from './RenameFolder.vue';
import Copy from './Copy.vue';
import ExportToDrive from './ExportToDrive.vue';

import { EventBus } from '../../mixins';

const store = useStore();

const showMenu = ref(false);

const x = ref(0);

const y = ref(0);

const selectedItem = ref(null);

const items = ref([
  { title: 'Copie', ref: 'copyPopup', icon: 'file_copy', isDir: false, showOnReadWorkspace: true },
  { title: 'Déplacer', ref: 'moveToPopup', icon: 'folder_open', isDir: false },
  { title: 'Supprimer', ref: 'deletePopup', icon: 'delete', isDir: false },
  { title: 'Renommer', ref: 'renamePopup', icon: 'edit', isDir: true },
  { title: 'Supprimer', ref: 'deletePopup', icon: 'delete', isDir: true }

]);

const itemsToShow = computed(() => {
  const isDirectory = selectedItem.value.wtype === 'folder';
  // Filters depending on directory or content, if has permission to write and if has writeWorkspaces to copy to
  return items.value.filter(item => item.isDir === isDirectory && ((item.showOnReadWorkspace || store.getters.permissionToWrite) && store.state.currentUser.writeWorkspaces.length));
});

// Check if the workspace and wtype is exportable
const exportToGoogleDocs = computed(() => {
  if (store.getters.workspace.settings.VUE_APP_EXPORT_DRIVE && store.getters.workspace.settings.VUE_APP_EXPORT_DRIVE.length && selectedItem.value) {
    return store.getters.workspace.settings.VUE_APP_EXPORT_DRIVE.includes(selectedItem.value.wtype);
  }
  return false;
});

const refs = ref({});

const optionSelected = item => {
  refs.value[item.ref].open(selectedItem.value);
};

const close = () => {
  if (showMenu.value) {
    EventBus.$emit('unselectItem');
  }
};

const show = (e, item) => {
  e.preventDefault();
  selectedItem.value = item;

  x.value = e.clientX;
  y.value = e.clientY;
  nextTick(() => {
    showMenu.value = true;
  });
};

// eslint-disable-next-line no-undef
defineExpose({ show });

</script>

<style scoped>
    .menu {
        margin: 0 auto;
        max-width: 600px;
        min-width: 120px;
        width: 120px;
    }

    .googlePickerButton{
      cursor: pointer;
    }

    .googlePickerButton:hover{
      background-color: rgba(0, 0, 0, 0.03);
    }
</style>
